import { Image } from 'react-native';
export default Image;
//# sourceMappingURL=FastImage.web.js.map